// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import HttpService from 'src/lib/HttpService';

const DEFAULT_COUNTRIES_URL =
    'api/ustrl/v1.0/api/location/geography?isoType=country';
const DEFAULT_PROVINCES_URL =
    'api/ustrl/v1.0/api/location/geography?isoType=province';
export default {
    async getCountriesList() {
        const response = await HttpService.proxiedApiCall({
            requestUrl: `${DEFAULT_COUNTRIES_URL}`,
            type: 'get',
        });

        return response;
    },

    async getProvinces() {
        const response = await HttpService.proxiedApiCall({
            requestUrl: `${DEFAULT_PROVINCES_URL}`,
            type: 'get',
        });

        return response;
    },
};
